import React from "react";
import ServiceRequestForm from "./ServiceRequestForm";

export default function PrinterServiceRequestForm() {
  return <ServiceRequestForm serviceType="PrinterService" title="Printer" />;
}

